const DEVIATIONS_BY_CITY = new Map([
  ['Paris', 4000],
  ['Lyon', 3000],
  ['Marseille', 2000]
]);


function applyRandomDeviation(pos, maxDeviationRadius) {
  // Generate random polar coordinates
  let radius = Math.random() * maxDeviationRadius,
    angle = Math.random() * 2 * Math.PI;
  // Convert them to cartesian
  let dx = radius * Math.cos(angle),
    dy = radius * Math.sin(angle);

  let lng = pos[0],
    lat = pos[1];

  // https://stackoverflow.com/questions/7477003/calculating-new-longitude-latitude-from-old-n-meters
  const r_earth = 6371000.0;
  var newLat  = lat  + (dy / r_earth) * (180 / Math.PI),
    newLng = lng + (dx / r_earth) * (180 / Math.PI) / Math.cos(lat * Math.PI/180);

  return new window.mapboxgl.LngLat(newLng, newLat);
}


function createOrUpdatePositionMarker(marker, center, cityLabel, icon='-default') {
  // Meters around original point
  let maxDeviationRadius = DEVIATIONS_BY_CITY.get(cityLabel) || process.env.REACT_APP_MAX_DEVIATION_FROM_CITY_CENTER;

  let newCenter = applyRandomDeviation(center, maxDeviationRadius);
  if (marker === null) {
    var el = document.createElement('div');
    el.className = `gp-marker marker-${icon}`;
    marker = new window.mapboxgl.Marker(el,
      {
        draggable: false,
        anchor: 'bottom'
      })
      .setLngLat(newCenter)
      .addTo(window.map);
  }
  marker.setLngLat(newCenter);

  window.map.flyTo({center: newCenter});
  return marker;
}


class DisableSingleTouch {

  touchStart = (event) => {
    if (event.touches.length === 2) {
      this.map.dragPan.enable();
    }
  }

  touchEnd = (event) => {
    this.map.dragPan.disable();
  }

  onAdd(map) {
    this.map = map;
    this.container = document.createElement('div');

    this.map.getContainer().addEventListener('touchstart', this.touchStart, true);
    this.map.getContainer().addEventListener('touchend', this.touchEnd, true);

    if ('ontouchstart' in document.documentElement) {
      // disable dragPan
      // it will be enabled only on two touchs events
      map.dragPan.disable();
    }
    return this.container;
  }

  onRemove() {
    this.map.getContainer().removeEventListener('touchstart', this.touchStart);
    this.map.getContainer().removeEventListener('touchmove', this.touchMove);
    this.map = undefined;
  }
}

export default DisableSingleTouch;


export {
  DisableSingleTouch,
  applyRandomDeviation, createOrUpdatePositionMarker
}
